module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stf-select stf-select_sm",
    class: {
      'stf-select_has-value': _vm.value !== null && _vm.value !== undefined ? true : false, 'stf-select_opened': _vm.isOpened, 'stf-select_empty': !_vm.options || !_vm.options.length
    },
    on: {
      "keydown": _vm.keyDown,
      "keypress": _vm.keyPress,
      "click": function($event) {
        $event.stopPropagation();
        _vm.open($event)
      },
      "unblur": _vm.onUnblur
    }
  }, [_c('div', {
    staticClass: "stf-select__container"
  }, [_c('div', {
    staticClass: "stf-select__inner-wrapper"
  }, [_c('div', {
    staticClass: "stf-select__value"
  }, [_vm._t("value")], 2), _vm._v(" "), _c('div', {
    staticClass: "stf-select__placeholder"
  }, [_vm._t("label")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "stf-select__search-input",
    attrs: {
      "tabindex": _vm.isOpened ? -1 : 0
    },
    on: {
      "focus": _vm.onSelectFocus
    }
  }, [_vm._t("search-input")], 2), _vm._v(" "), _c('div', {
    staticClass: "stf-select__options-wraped",
    class: {
      'stf-select_opened': _vm.isOpened, 'stf-select_empty': !_vm.options || !_vm.options.length
    },
    attrs: {
      "select-id": _vm.idSelect
    },
    on: {
      "keydown": _vm.keyDown
    }
  }, [(!_vm.isNeedHideOption) ? _c('div', {
    staticClass: "stf-select__options stf-select-options",
    attrs: {
      "role": "combobox",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    },
    on: {
      "mousewheel": _vm.onMouseWheal,
      "scroll": _vm.loadMore
    }
  }, [_c('div', {
    staticClass: "stf-select__options-container"
  }, [_vm._t("default")], 2)]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71d470a4"}!./src/components/stf-select/stf-select.html
// module id = 106
// module chunks = 1